/**
 * Created by justin on 7/16/14.
 */

var changeLog = angular.module('changeLog', ['classy', 'standardCudArray', 'applyDocuments']);
changeLog.classy.controller({
    name: 'ChangeLogController',
    inject: ['$scope', 'ChangeLogModelService'],
    init: function()
    {
        this.$.items = this.ChangeLogModelService.get();
    },
    isArray: function(o)
    {
        return (o instanceof Array);
    }

});

stateProviders.push({
    name: 'schoolside.settings.changeLog',
    url: '/changeLog',
    templateUrl: 'fast/submodules/schoolside/settings/changeLog/changeLog.html?v=' + versionNo,
    controller: 'ChangeLogController',
    resolve: {
        changeLog: function(ChangeLogModelService, SchoolModelService)
        {
            return ChangeLogModelService.resolveData(SchoolModelService.getSchoolID());
        }
    }
});

